module.exports = __webpack_public_path__ + "static/media/aquarius-orange.4c6d1449.jpg";